import { Control } from "react-hook-form";
import { MiBuildHouseAlt } from "@miplatform/assets";
import {
  MiControlledSelectBox,
  MiPlaceholderArea,
  MiSkeleton,
  SKELETON_VARIANTS,
} from "@miplatform/components";
import { TYPOGRAPHY_VARIANTS } from "@miplatform/constants";
import { ICategoriesResponse, ICategoryDropsResponse } from "@miplatform/types";
import { Box, Typography, useTheme } from "@mui/material";
import { IPriceLevelPayload } from "../../PricingMatrix/PricingMatrix.types";
import { PriceMatrixTable } from "../../PricingMatrix/components/PriceMatrixTable";
import { IAssignPriceLevelPayload } from "../CustomerPricingDetails/CustomerPricingDetails.types";

export const PriceLevelSelection = ({
  control,
  options,
  isLoading,
  priceLevels,
  groupedData,
}: PriceLevelSelectionProps) => {
  const theme = useTheme();

  return (
    <Box display="flex" flexDirection="column" gap={3}>
      <Typography
        variant={TYPOGRAPHY_VARIANTS.BODY2}
        color={theme.palette.text.secondary}
      >
        Select a price level for this customer. This pricing matrix is
        read-only.
      </Typography>
      <MiControlledSelectBox
        name="priceLevelId"
        label="Select Price Level"
        formControl={control}
        options={options}
        disabled={isLoading || options.length === 0}
        disableNone
      />
      {isLoading && (
        <MiSkeleton height={450} variant={SKELETON_VARIANTS.ROUNDED} />
      )}
      {!isLoading && priceLevels.length === 0 && (
        <MiPlaceholderArea
          text="No Pricing Matrix to Display"
          helperText="Tip: To select a price level, set up the pricing matrix first."
          iconComponent={<img src={MiBuildHouseAlt} alt="House Icon" />}
          containerStyle={{
            backgroundColor: theme.palette.primary.light,
            height: "100%",
            minHeight: 450,
          }}
        />
      )}
      {!isLoading && priceLevels.length > 0 && (
        <PriceMatrixTable
          readOnly
          priceLevels={priceLevels}
          groupedData={groupedData}
        />
      )}
    </Box>
  );
};

type PriceLevelSelectionProps = {
  control: Control<IAssignPriceLevelPayload>;
  options: {
    label: string;
    value: string;
  }[];
  isLoading: boolean;
  priceLevels: IPriceLevelPayload[];
  groupedData: {
    category: ICategoriesResponse;
    categoryDrop: ICategoryDropsResponse[];
  }[];
};
